import { v4 as uuidv4 } from 'uuid';

import { IKnmVideoFixation } from 'APIPackage/KnmModule/interfaces/IKnmVideoFixation';
import { IKnmErknmViolationEvidence } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmViolationEvidence';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { createTypeDocConfirmationViolationSelectOption } from 'CorePackage/CatalogsModule/common/createTypeDocConfirmationViolationSelectOption';
import {
  createPassportEventSelectOptions,
  IViolationEventSelectOption,
} from 'KnmErknmPackage/ErknmViolationsModule/common/createPassportEventSelectOptions';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { convertKnmDocumentAttachmentFormValueToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentFormValueToKnmData';

export function convertVideoFixationsToFormValues(
  videoFixations: IKnmVideoFixation[] | null | undefined,
  passportEvents?: IKnmErknmFormEvent[],
): IKnmErknmViolationEvidence[] | undefined {
  if (!videoFixations?.length) {
    return undefined;
  }

  const eventOptions = createPassportEventSelectOptions(passportEvents);

  return videoFixations.map(fix => ({
    guid: fix.guid || null,
    eventOption: fix.event?.guid ? eventOptions.find(option => option.value === fix.event?.guid) || null : null,
    typeDocConfirmationViolation: fix.typeDocConfirmationViolation
      ? createTypeDocConfirmationViolationSelectOption(fix.typeDocConfirmationViolation)
      : null,
    date: convertInitialKnmDateToFormDate(fix.dateVideo, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
    description: fix.descVideo ?? undefined,
    link: fix.linkVideo ?? undefined,
    attachments: fix.attachments?.length
      ? fix.attachments.map(attachment => ({
          ...attachment,
          isNew: false,
        }))
      : null,
    originPassportId: fix.originPassportId,
    listId: uuidv4(),
    isNew: false,
  }));
}

export function convertViolationEvidencesFormValuesToVideoFixations(
  evidences: IKnmErknmViolationEvidence[] | undefined | null,
): IKnmVideoFixation[] | null {
  if (!evidences?.length) {
    return null;
  }

  return evidences.map(evi => {
    const typeDoc = evi.typeDocConfirmationViolation;
    const eventOption = evi.eventOption as IViolationEventSelectOption | null | undefined;
    const eventType =
      eventOption?.eventType?.dictId && eventOption?.eventType?.dictVersionId
        ? {
            dictId: eventOption.eventType.dictId,
            dictVersionId: eventOption.eventType.dictVersionId,
          }
        : null;

    return {
      guid: evi.guid || null,
      event: eventOption?.value
        ? {
            guid: eventOption.value,
            eventType,
          }
        : null,
      typeDocConfirmationViolation: typeDoc
        ? {
            id: typeDoc.id,
            code: typeDoc.code,
            name: typeDoc.name,
          }
        : null,
      dateVideo: convertFormDateValueToKnmDataDate(evi.date),
      descVideo: evi.description,
      linkVideo: evi.link || null,
      attachments:
        evi.attachments
          ?.map(attachmentItem => convertKnmDocumentAttachmentFormValueToKnmData(attachmentItem))
          .filter((item): item is NonNullable<typeof item> => !!item) || null,
      originPassportId: evi.originPassportId,
    };
  });
}
